import {t} from '../../../../common/getTranslations';
import {showSimpleDialog} from '../../../../dialog/simpleDialogHandler';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';

export function showRefundDialog({
  isMobile,
  onClickRefundButton,
}: {
  isMobile?: boolean;
  onClickRefundButton?: VoidFunction;
}) {
  showSimpleDialog({
    title: t('contenthome_ticket_refund_title'),
    description: t('contenthome_ep_tab_ticket_refund_popup'),
    isMobile: Boolean(isMobile),
    eventLog: {
      click: {
        layer1: '환불팝업',
        imp_id: 'popup',
        imp_provider: 'service',
      },
      viewimp_contents: {
        imp_id: 'popup',
        imp_provider: 'service',
        imp_type: 'vimp',
        layer1: '환불팝업',
      },
      customProps: {popup_type: '환불팝업'},
    },
    okButton: {
      text: t('common_confirm_button'),
      type: 'label',
      onClick: e => {
        LOG_CLICK_EVENT('환불팝업_확인_클릭', e, onClickRefundButton);
      },
      closeAfterClick: true,
    },
    cancelButton: {
      type: 'label',
      onClick: e => {
        LOG_CLICK_EVENT('환불팝업_취소_클릭', e);
      },
    },
  });
}
